module.exports = __webpack_public_path__ + "static/passport-hand2-ce0f9c7c0617a7f2a49ceef8c1b4b203.png";